import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Input,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "@material-tailwind/react";
import {
  validateZipCode,
  validateState,
  validUSAStates,
  validateNotEmpty,
} from "../../helpers/validationHelpers";

import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useWallet, useAddress } from "@thirdweb-dev/react";

export function ProviderSignup() {
  const [formData, setFormData] = useState({
    walletAddress: "0x00",
    providerName: "",
    providerType: "",
    contactInformation: {
      address1: "",
      address2: "",
      state: "",
      zipcode: "",
    },
    medicalLicenseNumber: "",
    contractAddress: [],
  });

  const [zipcodeValidationColor, setZipcodeValidationColor] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate(); // Instantiate useNavigate hook
  //const handleOpen = () => setOpen(!open);
  const walletInstance = useWallet();
  const walletAddressFronAddress = useAddress();

  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [isConnectWalletModalOpen, setIsConnectWalletModalOpen] = useState(false);

  useEffect(() => {
    setIsWalletConnected(!!walletInstance);
    if (walletInstance && walletAddress) {
      setIsWalletConnected(true);
      setWalletAddress(walletAddressFronAddress);
      setFormData((prevState) => ({
        ...prevState,
        walletAddress, // <-- update walletAddress in formData
      }));
    }
  }, [walletInstance, walletAddress]);

  const closeAndRedirect = () => {
    setModalOpen(false); // Close the modal
    navigate("/dashboard"); // Navigate to /dashboard
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (['address1', 'address2', 'state', 'zipcode'].includes(name)) {
        // Handle nested contactInformation object
        setFormData(prevState => ({
            ...prevState,
            contactInformation: {
                ...prevState.contactInformation,
                [name]: value,
            },
        }));
    } else {
        // Handle top-level properties
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }
    if (name === "zipcode") {
      const isValidZip = await validateZipCode(value);
      setZipcodeValidationColor(isValidZip ? "green" : "red");
    }
    if (name === "state") {
      // If you want to handle invalid state input
      const isValidState = validateState(value);
      if (!isValidState) {
        console.error("Invalid state");
      }
    }
  };

  const closeModal = () => {
    setIsConnectWalletModalOpen(false);
  };

  const validateForm = () => {
    // Reset error message
    setErrorMsg("");

    // Check if ProviderName, ProviderType, or MedicalLicenseNumber are empty
    if (!formData.providerName) {
      setErrorMsg("Provider Name is required.");
      return false;
    }
    if (!formData.providerType) {
      setErrorMsg("Provider Type is required.");
      return false;
    }
    if (!formData.medicalLicenseNumber) {
      setErrorMsg("Medical License Number is required.");
      return false;
    }

    // If all validations pass
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (!isWalletConnected) {
        setIsConnectWalletModalOpen(true);
      } else {
        try {
          // Send a POST request to your backend
          const response = await axios.post(
            "http://127.0.0.1:3001/create-provider",
            formData
          );
          setModalOpen(true); // Open the modal on successful submission
          setFormData({
            walletAddress: "",
            providerName: "",
            providerType: "",
            contactInformation: {
              address1: "",
              address2: "",
              state: "",
              zipcode: "",
            },
            medicalLicenseNumber: "",
            contractAddress: [],
          }); // Reset the form data
          console.log("Provider created successfully:", response.data);
        } catch (error) {
          console.error(
            "An error occurred while creating the provider:",
            error
          );
        }
      }
    }
  };

  return (
    <div className="flex justify-center items-center h-full">
      <Card className="ml-5 mt-6 w-full md:max-w-screen-md lg:w-96">
        <CardBody>
          <Typography variant="h2" color="blue">
            Provider Sign Up
          </Typography>
          <form onSubmit={handleSubmit}>
            {/* ...Rest of your input fields... */}
            {/* New Input Fields */}
            <div className="w-90 mb-5">
              <Input
                color="blue"
                label="Provider Name*"
                name="providerName"
                value={formData.providerName}
                onChange={handleChange}
                autocomplete="off"
                // Assuming a red border color for validation failure
                style={{
                  borderColor: validateNotEmpty(formData.providerName)
                    ? ""
                    : "",
                }}
              />
            </div>
            <div className="w-90 mb-5">
              <Input
                color="blue"
                label="Provider Type*"
                name="providerType"
                value={formData.providerType}
                onChange={handleChange}
                autocomplete="off"
                // Assuming a red border color for validation failure
                style={{
                  borderColor: validateNotEmpty(formData.providerType)
                    ? ""
                    : "red",
                }}
              />
            </div>
            <div className="w-90 mb-5">
              <Input
                color="blue"
                label="Medical License Number*"
                name="medicalLicenseNumber"
                style={{
                  borderColor: validateNotEmpty(formData.medicalLicenseNumber)
                    ? ""
                    : "red",
                }}
                value={formData.medicalLicenseNumber}
                onChange={handleChange}
                autocomplete="off"
              />
            </div>
            <div className="w-90 mb-5">
              <Input
                color="blue"
                label="Address 1*"
                name="address1"
                value={formData.address1}
                onChange={handleChange}
                autocomplete="off"
              />
            </div>
            <div className="w-90 mb-5">
              <Input
                color="blue"
                label="Address 2"
                name="address2"
                value={formData.address2}
                onChange={handleChange}
                autocomplete="off"
              />
            </div>
            <div className="w-90 mb-5">
              <label className="block text-blue-500 text-sm font-bold mb-2">
                State*
              </label>
              <Select
                name="state"
                options={validUSAStates.map((state) => ({
                  value: state,
                  label: state,
                }))}
                value={{ value: formData.state, label: formData.state }}
                onChange={(selectedOption) =>
                  handleChange({
                    target: { name: "state", value: selectedOption.value },
                  })
                }
              />
            </div>
            <div className="w-90 mb-5">
              <Input
                color="blue"
                label="Zipcode*"
                name="zipcode"
                value={formData.zipcode}
                onChange={handleChange}
                autocomplete="off"
                style={{ borderColor: zipcodeValidationColor }}
              />
            </div>
          </form>
          {errorMsg && <div className="error-message">{errorMsg}</div>}
        </CardBody>
        <CardFooter className="pt-0">
          <Button color="teal" onClick={handleSubmit} type="button">
            Submit
          </Button>
        </CardFooter>
      </Card>

      {/* Success Modal */}
      <Dialog open={modalOpen} handler={() => setModalOpen(false)}>
        <DialogHeader>Submission Successful</DialogHeader>
        <DialogBody>
          Your provider information has been submitted successfully.
        </DialogBody>
        <DialogFooter>
          <Button color="green" onClick={closeAndRedirect}>
            OK
          </Button>
        </DialogFooter>
      </Dialog>

      {/* Connect Wallet Modal */}
      <Dialog
        open={isConnectWalletModalOpen}
        onClose={closeModal}
        animate={{
          mount: { top: "0%", right: "0%", transition: "slideInRight" },
          unmount: { top: "0%", right: "-100%", transition: "slideOutRight" }
        }}
      >
        <div className="p-4 text-center">
          <span className="text-6xl" role="img" aria-label="Wallet Emoji">👛</span>
          <p className="mt-4 text-xl font-bold">Please connect your wallet to proceed.</p>
          <Button 
            color="gray" 
            variant="outline" 
            onClick={closeModal} 
            className="mt-4 text-white"
          >
            Cool, Thanks!
          </Button>
        </div>
      </Dialog>

    </div>
  );
}
